import { render, staticRenderFns } from "./standardslistModel.vue?vue&type=template&id=2be3471a&scoped=true"
import script from "./standardslistModel.vue?vue&type=script&lang=js"
export * from "./standardslistModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be3471a",
  null
  
)

export default component.exports